import { FormControl, TextField, Typography } from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";
import dropdown from "../../ressources/images/dropdown.svg";
import styles from "./styles";
import { FieldRenderProps } from "react-final-form";

export interface DropdownItem {
  key: string | number;
  text: string;
  value: string | number;
  simpleField?: boolean;
  size?: number;
}

interface IOwnProps {
  disabled?: boolean;
  initialValue?: string;
  input?: { value: any; onChange: (value: any) => void };
  label: string;
  meta?: { error?: string; touched?: boolean; initial?: string };
  options: DropdownItem[];
  readOnly?: boolean;
  required?: boolean;
  placeholder?: string;
}

const svgIcon = (props: any) => <img src={dropdown} {...props} alt="" />;

const Select: React.FC<IOwnProps & FieldRenderProps<any, HTMLElement, any>> = ({
  disabled = false,
  label,
  meta,
  options,
  required = false,
  readOnly = false,
  placeholder = "",
  input,
}) => {
  const [value, setValue] = useState<string | number>(
    (options.length > 0 && (input?.value || meta?.initial)) || ""
  );
  if (value && options.length > 0) {
    const findOption = options.filter((o) => o.value === value).length > 0;
    if (!findOption) {
      setValue("");
    }
  }
  useEffect(() => {
    const newValue =
      (options.length > 0 && (input?.value || meta?.initial)) || "";
    const isValidOption =
      newValue && options.some((option) => option.value === newValue);

    setValue(isValidOption ? newValue : "");
  }, [options, input?.value, meta?.initial]);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const selectedValue = e.target.value;
    setValue(selectedValue);
    input?.onChange(selectedValue);
  };

  return (
    <FormControl classes={{ root: "root" }} sx={styles}>
      <TextField
        id="outlined-select"
        error={!!meta?.touched && !!meta?.error}
        select
        label={label}
        value={value}
        onChange={handleChange}
        required={required}
        disabled={disabled || readOnly}
        InputProps={{
          className: "underline",
          classes: {
            input: "select",
            // root: "select",
          },
        }}
        SelectProps={{
          native: true,
          IconComponent: svgIcon,
          classes: {
            // root: "select",
          },
        }}
        InputLabelProps={{
          className: "textFieldLabel",
        }}
        variant="filled"
        className="textFieldRoot"
      >
        <option disabled value="">
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.key} value={option.value}>
            {option.text}
          </option>
        ))}
      </TextField>
      {meta?.touched && meta.error && (
        <Typography color="error" variant="caption">
          {meta.error}
        </Typography>
      )}
    </FormControl>
  );
};

export default Select;
